<template>
  <q-card
    :style="outcomeStyle"
    class="card q-mx-auto"
    style="max-width: 756px; width: 100%; height: 570px"
  >
    <q-scroll-area
      :thumb-style="{
        background: '#162c479c',
        opacity: 1,
        width: '8px',
        height: '8px',
        borderRadius: '20px',
      }"
      style="width: 756px; height: 100%"
      class="q-px-md"
    >
      <div class="row justify-between">
        <div>
          <q-tabs v-model="tab" inline-label>
            <q-tab
              :name="tab.name"
              no-caps
              v-for="(tab, i) in tabs"
              :key="i"
              :disable="tab.disable"
            >
              <div class="row items-center text-accent">
                <q-icon :name="tab.icon" size="xs"> </q-icon>
                <span class="tabTitle q-ml-sm"> {{ tab.label }}</span>
              </div>
            </q-tab>
          </q-tabs>
        </div>
        <q-btn icon="mdi-close" flat round @click="closeDialog" class="q-mr-sm">
        </q-btn>
      </div>
      <div class="row" v-if="data">
        <q-tab-panels v-model="tab" class="full-width">
          <q-tab-panel name="externalFactor">
            <div class="row q-mt-lg">
              <span class="title text-accent"> {{ data.name }}</span>
            </div>
            <div class="row">
              <span class="totalAndUnit">
                {{ data.total | numberFormat }}

                {{
                  selectedOutcome.factorUnitDisplay
                    ? selectedOutcome.factorUnitDisplay
                    : data.unit
                }}</span
              >
            </div>
            <div class="row" v-if="$route.params.hasOwnProperty('year')">
              <span class="year text-accent">
                in {{ $route.params.year }}
              </span>
            </div>
            <q-form ref="form" class="q-mt-lg">
              <div class="row">
                <span class="inputLabel">Which generated</span>
              </div>
              <div class="row items-center q-mb-sm">
                <div class="q-mr-sm">
                  <q-input
                    class="inputField"
                    v-model="value"
                    filled
                    :rules="[
                      (v) => !!v || 'Field is Required',
                      (val) =>
                        !isNaN(parseFloat(val)) || 'Value must be a number',
                    ]"
                    dense
                    hide-bottom-space
                  >
                  </q-input>
                </div>
                <div class="totalAndUnit">
                  {{
                    selectedOutcome.factorUnitDisplay
                      ? selectedOutcome.factorUnitDisplay
                      : unit
                  }}
                </div>
              </div>
              <div class="row q-mt-lg">
                <p class="q-mb-xs text-accent description">
                  Please enter the total amount of Carbon Emissions for this
                  source based on your external source. <br />
                  Due to the fact you are externally overriding our calculator
                  with external figures, we don’t take responsibility for any
                  errors or miscalculations
                </p>
              </div>
              <div class="row">
                <span class="inputLabel">Notes</span>
              </div>
              <div class="row">
                <q-input
                  type="textarea"
                  v-model="notes"
                  filled
                  class="full-width"
                >
                </q-input>
              </div>
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
      </div>
      <div class="row justify-end q-px-md">
        <q-btn no-caps class="saveBtn" @click="submit">
          <span class="text text-white">Save</span>
        </q-btn>
      </div>
    </q-scroll-area>
  </q-card>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      outcomeStyle: {
        type: Object,
        default: {},
      },
    },
    computed: {
      ...mapGetters({
        data: "sources/data/selectedData",
        customSourcesBusinessTotalData:
          "customSourcesBusinessTotal/selectedCustomSourcesBusinessTotal",
        selectedOutcome: "general/selectedOutcome",
      }),
      unit() {
        return this.data && this.data.emissionsFactor
          ? this.data.emissionsFactor[0].unit
          : this.data.unit;
      },
    },

    mounted() {
      this.init();
    },
    data: () => ({
      tab: "externalFactor",
      value: "",
      notes: "",
      tabs: [
        {
          name: "externalFactor",
          label: "Enter your external carbon emission factors",
          icon: "mdi-file-document-box",
          disable: false,
        },
      ],
    }),
    methods: {
      closeDialog() {
        this.$emit("closeDialog");
      },
      initForm() {
        if (this.customSourcesBusinessTotalData) {
          this.value = this.selectedOutcome.factorMultiplier
            ? this.selectedOutcome.factorMultiplier *
              this.customSourcesBusinessTotalData.totalValue
            : this.customSourcesBusinessTotalData.totalValue;
          this.notes = this.customSourcesBusinessTotalData.notes;
        }
      },
      init() {
        if (this.$route.params.hasOwnProperty("sourceId")) {
          if (
            this.$route.params.hasOwnProperty("sourceId") &&
            this.$route.params.hasOwnProperty("year")
          ) {
            this.$store.dispatch("sources/data/loadBySourceIDAndYear", {
              sourceId: this.$route.params.sourceId,
              year: this.$route.params.year,
            });
            this.$store
              .dispatch(
                "customSourcesBusinessTotal/loadBySourceID",
                this.$route.params.sourceId
              )
              .then((e) => {
                this.initForm();
              });
          }
        }
      },
      async submit() {
        let isValid = await this.$refs.form.validate();
        if (isValid) {
          if (this.customSourcesBusinessTotalData) {
            this.save();
          } else {
            this.createNew();
          }
        }
      },
      async save() {
        let result = await this.$store.dispatch(
          "customSourcesBusinessTotal/new",
          {
            notes: this.notes,
            totalValue: this.selectedOutcome.factorMultiplier
              ? this.value / this.selectedOutcome.factorMultiplier
              : this.value,
            useCustom: 1,
            sources_id: this.$route.params.sourceId,
            date: this.$route.params.year,
          }
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
        this.closeDialog();
      },
      async createNew() {
        let result = await this.$store.dispatch(
          "customSourcesBusinessTotal/new",
          {
            notes: this.notes,
            totalValue: this.selectedOutcome.factorMultiplier
              ? this.value / this.selectedOutcome.factorMultiplier
              : this.value,
            sources_id: this.$route.params.sourceId,
            useCustom: 1,
            date: this.selectedYear,
          }
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
        this.closeDialog();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    color: $accent;
    font-weight: 900;
    font-size: 15.9366px;
  }

  .tabTitle {
    font-weight: 700;
    font-size: 14px;
  }

  .totalAndUnit {
    font-weight: 900;
    font-size: 27.0146px;
    color: var(--outcome-primary);
  }

  .year {
    color: $accent;

    font-weight: 900;
    font-size: 15.9362px;
  }

  .inputLabel {
    font-weight: 900;
    font-size: 12px;
    color: $accent;
  }

  .inputField {
    width: 306px;
    height: 40px;
  }

  .saveBtn {
    width: 133px;
    height: 34px;
    border-radius: 3px;
    background-color: var(--outcome-primary);

    .text {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 500;
      font-size: 9px;
    }
  }
  .description {
    font-size: 0.8rem;
  }
</style>
